export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
};

export type ApiKey = {
  __typename?: 'ApiKey';
  accessToken: Scalars['String'];
  deviceName?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
};

export type Archive = {
  __typename?: 'Archive';
  displayLogo: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  profilePicture?: Maybe<Attachment>;
};

export type Artist = {
  __typename?: 'Artist';
  artistType?: Maybe<Constant>;
  awards?: Maybe<Scalars['String']>;
  bandcamp?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: Maybe<Gender>;
  id: Scalars['Int'];
  knowledgeCredits?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  musicInstrument?: Maybe<MusicalInstrument>;
  performances?: Maybe<Scalars['String']>;
  playlist?: Maybe<PlaylistBase>;
  profilePicture?: Maybe<Attachment>;
  website?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
};

export type ArtistProfilePictureArgs = {
  resolution?: InputMaybe<Scalars['String']>;
};

export type ArtistList = {
  __typename?: 'ArtistList';
  data?: Maybe<Array<Artist>>;
  paging: Paging;
};

/** The connection type for Artist. */
export type ArtistsConnection = {
  __typename?: 'ArtistsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ArtistsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Artist>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ArtistsEdge = {
  __typename?: 'ArtistsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Artist>;
};

export type Attachment = {
  __typename?: 'Attachment';
  filename: Scalars['String'];
  id: Scalars['Int'];
  url: Scalars['String'];
};

export type Base = {
  __typename?: 'Base';
  id: Scalars['Int'];
  position: Scalars['Int'];
  song?: Maybe<BaseSongType>;
};

export type BaseSongType = {
  __typename?: 'BaseSongType';
  archive?: Maybe<Archive>;
  artists: ArtistsConnection;
  highQuality?: Maybe<Attachment>;
  hlsUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isFavourited: Scalars['Boolean'];
  language: Constant;
  laya: Constant;
  lowQuality?: Maybe<Attachment>;
  lyrics?: Maybe<Scalars['String']>;
  mediumQuality?: Maybe<Attachment>;
  preview?: Maybe<Attachment>;
  raga: Raga;
  taal: Constant;
  title: Scalars['String'];
  trackLength: Scalars['Int'];
  year: Scalars['Int'];
};

export type BaseSongTypeArtistsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type BaseStreamEventType = {
  __typename?: 'BaseStreamEventType';
  eventType: Scalars['String'];
  id: Scalars['Int'];
  trackPosition: Scalars['Int'];
};

export type BaseStreamType = {
  __typename?: 'BaseStreamType';
  favouriteMetadata?: Maybe<FavouriteMetadataStream>;
  id: Scalars['Int'];
  isPreviousAvailable: Scalars['Boolean'];
  playlistMetadata?: Maybe<PlaylistMetadataStream>;
  song: BaseSongType;
  timeSection: TimeSection;
  timeSectionHour: TimeSectionHour;
};

export type Constant = {
  __typename?: 'Constant';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum ConstantTypes {
  ArtistType = 'artist_type',
  Jaati = 'jaati',
  Language = 'language',
  Laya = 'laya',
  MusicInstrument = 'music_instrument',
  Swar = 'swar',
  Taal = 'taal',
  Thaat = 'thaat',
}

/** Attributes needed to trigger a contact message */
export type ContactMessageInput = {
  email: Scalars['String'];
  message: Scalars['String'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type CurrentUser = {
  __typename?: 'CurrentUser';
  activeSubscription?: Maybe<Subscription>;
  addressLinePincode?: Maybe<Scalars['String']>;
  addressLinePrimary?: Maybe<Scalars['String']>;
  addressLineSecondary?: Maybe<Scalars['String']>;
  addressLineState?: Maybe<Scalars['String']>;
  addressLineTertiary?: Maybe<Scalars['String']>;
  confirmedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  dateOfBirth?: Maybe<Scalars['ISO8601DateTime']>;
  email: Scalars['String'];
  favourites?: Maybe<FavouritesList>;
  firstName: Scalars['String'];
  gender?: Maybe<Gender>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  playbackPreference?: Maybe<PlaybackPreferencesObject>;
  profilePicture?: Maybe<Attachment>;
  /** Payment History */
  successfulTransactions?: Maybe<Array<Transaction>>;
};

export type CurrentUserFavouritesArgs = {
  page: Scalars['Int'];
  perPage?: InputMaybe<Scalars['Int']>;
};

export type CurrentUserProfilePictureArgs = {
  resolution?: InputMaybe<Scalars['String']>;
};

export type CurrentUserUpdateInput = {
  addressLinePincode?: InputMaybe<Scalars['String']>;
  addressLinePrimary?: InputMaybe<Scalars['String']>;
  addressLineSecondary?: InputMaybe<Scalars['String']>;
  addressLineState?: InputMaybe<Scalars['String']>;
  addressLineTertiary?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  playbackPreference?: InputMaybe<PlaybackPreferencesInput>;
};

export type Event = {
  currentStreamId: Scalars['Int'];
  eventType: StreamEvent;
  trackPosition: Scalars['Int'];
};

export type FavouriteMetadataStream = {
  __typename?: 'FavouriteMetadataStream';
  isNextFavouriteAvailable?: Maybe<Scalars['Boolean']>;
  isPreviousFavouriteAvailable?: Maybe<Scalars['Boolean']>;
  positionInFavourites?: Maybe<Scalars['Int']>;
  totalFavouritesCount?: Maybe<Scalars['Int']>;
  totalFavouritesDuration?: Maybe<Scalars['Int']>;
};

export type FavouritesList = {
  __typename?: 'FavouritesList';
  data?: Maybe<Array<Base>>;
  paging: Paging;
  totalDuration?: Maybe<Scalars['Int']>;
};

export enum Gender {
  Female = 'female',
  Male = 'male',
  NonBinary = 'non_binary',
  Undisclosed = 'undisclosed',
}

export type GiftInput = {
  receiverEmail: Scalars['String'];
  receiverName: Scalars['String'];
  senderEmail: Scalars['String'];
  senderName: Scalars['String'];
  subscriptionPlanId: Scalars['Int'];
};

export type IapIosReceiptInput = {
  amountCents: Scalars['Int'];
  currency: Scalars['String'];
  receiptValue: Scalars['String'];
};

export type Login = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export enum LogoVersion {
  Orange = 'orange',
  White = 'white',
}

export type MusicalInstrument = {
  __typename?: 'MusicalInstrument';
  id: Scalars['Int'];
  name: Scalars['String'];
  playlist?: Maybe<PlaylistBase>;
  profilePicture?: Maybe<Attachment>;
};

export type MusicalInstrumentProfilePictureArgs = {
  resolution?: InputMaybe<Scalars['String']>;
};

export type MusicalInstrumentList = {
  __typename?: 'MusicalInstrumentList';
  data?: Maybe<Array<MusicalInstrument>>;
  paging: Paging;
};

export type Mutation = {
  __typename?: 'Mutation';
  authApple: ApiKey;
  authConfrmEmail: ApiKey;
  authFacebook: ApiKey;
  authForgotPassword: Scalars['Boolean'];
  authGoogle: ApiKey;
  authLogin: ApiKey;
  authLogout: Scalars['Boolean'];
  authResendVerificationEmail: Scalars['Boolean'];
  authResetPassword: ApiKey;
  authSignUp: ApiKey;
  contactMessage: Scalars['Boolean'];
  /** Create a gift transaction */
  createGiftTransaction: Transaction;
  currentUserDelete: Scalars['Boolean'];
  currentUserUpdate: CurrentUser;
  /** Favourite a song */
  favouriteSong?: Maybe<FavouritesList>;
  /** Cancel a recurring subscription */
  paymentCancelSubscription: Subscription;
  /** Create a subscription */
  paymentCreateSubscription: Transaction;
  /** Create a transaction */
  paymentCreateTransaction: Transaction;
  /** Verify a receipt from the apple app store subscriptions */
  paymentVerifyIosReceipt: Subscription;
  /** Verify a subscription */
  paymentVerifySubscription: Subscription;
  /** Verify a payment */
  paymentVerifyTransaction: Subscription;
  /** Redeem a gift subscription */
  redeemGiftTransaction: Subscription;
  /** Emit a stream event */
  streamEvent: Scalars['Boolean'];
  /** Store an array for stream events */
  streamEventBulk?: Maybe<Scalars['Boolean']>;
  /** unFavourite a song */
  unfavouriteSong?: Maybe<FavouritesList>;
  /** Verify a gift transaction */
  verifyGiftTransaction: Transaction;
};

export type MutationAuthAppleArgs = {
  appleIdToken: Scalars['String'];
  fullName?: InputMaybe<Scalars['String']>;
};

export type MutationAuthConfrmEmailArgs = {
  confirmationToken: Scalars['String'];
};

export type MutationAuthFacebookArgs = {
  facebookAccessToken: Scalars['String'];
};

export type MutationAuthForgotPasswordArgs = {
  email: Scalars['String'];
};

export type MutationAuthGoogleArgs = {
  googleServerAuthCode: Scalars['String'];
};

export type MutationAuthLoginArgs = {
  auth: Login;
};

export type MutationAuthResendVerificationEmailArgs = {
  email: Scalars['String'];
};

export type MutationAuthResetPasswordArgs = {
  auth: ResetPassword;
};

export type MutationAuthSignUpArgs = {
  auth: SignUp;
};

export type MutationContactMessageArgs = {
  contactMessage: ContactMessageInput;
};

export type MutationCreateGiftTransactionArgs = {
  gift: GiftInput;
};

export type MutationCurrentUserUpdateArgs = {
  user: CurrentUserUpdateInput;
};

export type MutationFavouriteSongArgs = {
  page: Scalars['Int'];
  perPage?: InputMaybe<Scalars['Int']>;
  songId: Scalars['Int'];
};

export type MutationPaymentCancelSubscriptionArgs = {
  subscriptionId: Scalars['Int'];
};

export type MutationPaymentCreateSubscriptionArgs = {
  couponCode?: InputMaybe<Scalars['String']>;
  subscriptionPlanId: Scalars['Int'];
};

export type MutationPaymentCreateTransactionArgs = {
  couponCode?: InputMaybe<Scalars['String']>;
  subscriptionPlanId: Scalars['Int'];
};

export type MutationPaymentVerifyIosReceiptArgs = {
  receiptData: IapIosReceiptInput;
};

export type MutationPaymentVerifySubscriptionArgs = {
  rzpSubscriptionId: Scalars['String'];
};

export type MutationPaymentVerifyTransactionArgs = {
  rzpOrderId: Scalars['String'];
};

export type MutationRedeemGiftTransactionArgs = {
  giftCode: Scalars['String'];
};

export type MutationStreamEventArgs = {
  currentStreamId: Scalars['Int'];
  eventType: StreamEvent;
  trackPosition: Scalars['Int'];
};

export type MutationStreamEventBulkArgs = {
  streamEventBulk: Array<Event>;
};

export type MutationUnfavouriteSongArgs = {
  page: Scalars['Int'];
  perPage?: InputMaybe<Scalars['Int']>;
  songId: Scalars['Int'];
};

export type MutationVerifyGiftTransactionArgs = {
  rzpOrderId: Scalars['String'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type Paging = {
  __typename?: 'Paging';
  /** Current page */
  currentPage: Scalars['Int'];
  /** Total items for the query */
  totalItems: Scalars['Int'];
  /** Total pages for the query */
  totalPages: Scalars['Int'];
};

export enum Payment {
  OneTime = 'one_time',
  Recurring = 'recurring',
}

export type Plan = {
  __typename?: 'Plan';
  currency?: Maybe<Scalars['String']>;
  currencySymbol?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  durationInDays: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  paymentType: Payment;
  price: Scalars['Float'];
  rzpPlanId?: Maybe<Scalars['String']>;
};

export type PlaybackPreferencesInput = {
  artistTypeId?: InputMaybe<Scalars['Int']>;
  continueInPrahar?: InputMaybe<Scalars['Boolean']>;
  languageId?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<PlaybackQuality>;
  voiceType?: InputMaybe<Voice>;
};

export type PlaybackPreferencesObject = {
  __typename?: 'PlaybackPreferencesObject';
  artistType?: Maybe<Constant>;
  continueInPrahar: Scalars['Boolean'];
  language?: Maybe<Constant>;
  quality?: Maybe<PlaybackQuality>;
  voiceType?: Maybe<Voice>;
};

export enum PlaybackQuality {
  HighQuality = 'high_quality',
  LowQuality = 'low_quality',
  MediumQuality = 'medium_quality',
}

export enum PlayingMode {
  Favourite = 'favourite',
  Playlist = 'playlist',
  Prahar = 'prahar',
}

export type PlaylistBase = {
  __typename?: 'PlaylistBase';
  coverArt?: Maybe<Attachment>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  owner: PlaylistOwner;
  playlistSongs?: Maybe<PlaylistSongList>;
  totalDuration?: Maybe<Scalars['Int']>;
};

export type PlaylistBaseCoverArtArgs = {
  resolution?: InputMaybe<Scalars['String']>;
};

export type PlaylistBasePlaylistSongsArgs = {
  page: Scalars['Int'];
  perPage?: InputMaybe<Scalars['Int']>;
};

export type PlaylistList = {
  __typename?: 'PlaylistList';
  data?: Maybe<Array<PlaylistBase>>;
  paging: Paging;
};

export type PlaylistMetadataStream = {
  __typename?: 'PlaylistMetadataStream';
  isNextPlaylistSongAvailable?: Maybe<Scalars['Boolean']>;
  isPreviousPlaylistSongAvailable?: Maybe<Scalars['Boolean']>;
  positionInPlaylist?: Maybe<Scalars['Int']>;
  totalPlaylistDuration?: Maybe<Scalars['Int']>;
  totalSongsInPlaylist?: Maybe<Scalars['Int']>;
};

/** Objects which can own a playlist */
export type PlaylistOwner = Artist | MusicalInstrument | Raga;

export type PlaylistSong = {
  __typename?: 'PlaylistSong';
  id: Scalars['Int'];
  position?: Maybe<Scalars['Int']>;
  song?: Maybe<BaseSongType>;
};

export type PlaylistSongList = {
  __typename?: 'PlaylistSongList';
  data?: Maybe<Array<PlaylistSong>>;
  paging: Paging;
};

export type Query = {
  __typename?: 'Query';
  /** Generate a login url for apple web */
  appleWebLogin: Scalars['String'];
  /** Get a particular artist */
  artist: Artist;
  /** Get a paginated list of artists */
  artistList: ArtistList;
  /** Introspect a user and get the current active access token's details */
  authIntrospect?: Maybe<ApiKey>;
  /** Get the list of constants for a given type */
  constantList: Array<Constant>;
  /** Get the current version of the constant cache */
  constantVersion: Scalars['Int'];
  /** Get a particular custom playlist */
  customPlaylist?: Maybe<PlaylistBase>;
  /** Get a paginated list of custom playlists */
  customPlaylistList: PlaylistList;
  /** Get a particular instrument */
  instrument: MusicalInstrument;
  /** Get a paginated list of instruments */
  instrumentList: MusicalInstrumentList;
  /** Get the list of streams for test */
  logList: Array<StreamLogType>;
  /** Play the next track */
  nextTrack: BaseStreamType;
  planProfile: Plan;
  /** Get a list of currently active plans */
  plans: Array<Plan>;
  /** Play the next track */
  previousTrack: BaseStreamType;
  /** Get a particular raga */
  raga?: Maybe<Raga>;
  /** Get a paginated list of ragas */
  ragaList: RagaList;
  /** Identify the current time section */
  timeSectionCurrent: TimeSection;
  /** Get the currently logged in user */
  userCurrent: CurrentUser;
};

export type QueryArtistArgs = {
  id: Scalars['Int'];
};

export type QueryArtistListArgs = {
  page: Scalars['Int'];
  perPage?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type QueryAuthIntrospectArgs = {
  auth: Login;
};

export type QueryConstantListArgs = {
  constantType: ConstantTypes;
};

export type QueryCustomPlaylistArgs = {
  id: Scalars['Int'];
};

export type QueryCustomPlaylistListArgs = {
  page: Scalars['Int'];
  perPage?: InputMaybe<Scalars['Int']>;
};

export type QueryInstrumentArgs = {
  id: Scalars['Int'];
};

export type QueryInstrumentListArgs = {
  page: Scalars['Int'];
  perPage?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type QueryLogListArgs = {
  streamCount: Scalars['Int'];
};

export type QueryNextTrackArgs = {
  artistTypeId?: InputMaybe<Scalars['Int']>;
  clientTime: Scalars['ISO8601DateTime'];
  currentStreamId?: InputMaybe<Scalars['Int']>;
  languageId?: InputMaybe<Scalars['Int']>;
  playingMode?: InputMaybe<PlayingMode>;
  playlistId?: InputMaybe<Scalars['Int']>;
  songId?: InputMaybe<Scalars['Int']>;
  voiceType?: InputMaybe<Gender>;
};

export type QueryPlanProfileArgs = {
  id: Scalars['Int'];
};

export type QueryPreviousTrackArgs = {
  clientTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  currentStreamId: Scalars['Int'];
};

export type QueryRagaArgs = {
  id: Scalars['Int'];
};

export type QueryRagaListArgs = {
  page: Scalars['Int'];
  perPage?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  timeSectionIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type QueryTimeSectionCurrentArgs = {
  clientTime: Scalars['ISO8601DateTime'];
};

export type Raga = {
  __typename?: 'Raga';
  aarohaSwars?: Maybe<Array<RagaSwar>>;
  avarohaSwars?: Maybe<Array<RagaSwar>>;
  id: Scalars['Int'];
  jaati?: Maybe<Constant>;
  notes?: Maybe<Scalars['String']>;
  pakadSwars?: Maybe<Array<RagaSwar>>;
  playlist?: Maybe<PlaylistBase>;
  samvadiSwar?: Maybe<Constant>;
  thaat?: Maybe<Constant>;
  timeSections?: Maybe<Array<TimeSection>>;
  title: Scalars['String'];
  vaadiSwar?: Maybe<Constant>;
};

export type RagaList = {
  __typename?: 'RagaList';
  data?: Maybe<Array<Raga>>;
  paging: Paging;
};

export type RagaSwar = {
  __typename?: 'RagaSwar';
  position: Scalars['Int'];
  swar: Constant;
};

export type ResetPassword = {
  password: Scalars['String'];
  resetPasswordToken: Scalars['String'];
};

/** Attributes for creating a user */
export type SignUp = {
  dateOfBirth?: InputMaybe<Scalars['ISO8601DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender: Gender;
  lastName?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

export enum StreamEvent {
  End = 'end',
  Heartbeat = 'heartbeat',
  NextTrack = 'next_track',
  Pause = 'pause',
  Play = 'play',
  PreviousTrack = 'previous_track',
  Seek = 'seek',
}

export type StreamLogType = {
  __typename?: 'StreamLogType';
  id: Scalars['Int'];
  isPreviousAvailable: Scalars['Boolean'];
  song: BaseSongType;
  streamCount?: Maybe<Scalars['Int']>;
  streamEvents?: Maybe<Array<BaseStreamEventType>>;
};

export type StreamLogTypeStreamEventsArgs = {
  streamEventCount?: InputMaybe<Scalars['Int']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  createdAt: Scalars['ISO8601DateTime'];
  expiresAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  renewalPolicy?: Maybe<SubscriptionRenewalPolicy>;
  subscriptionPlan: Plan;
};

export enum SubscriptionRenewalPolicy {
  AutoRenewal = 'auto_renewal',
  Cancelled = 'cancelled',
}

export type TimeSection = {
  __typename?: 'TimeSection';
  associatedTimeSectionHour: TimeSectionHour;
  backgroundVideo?: Maybe<Attachment>;
  description: Scalars['String'];
  endHour: Scalars['Int'];
  gradientBottomColour: Scalars['String'];
  gradientTopColour: Scalars['String'];
  id: Scalars['Int'];
  logoVersion: LogoVersion;
  name: Scalars['String'];
  playerBackground: Scalars['String'];
  playerBackgroundMobile: Scalars['String'];
  playerDropShadow: Scalars['String'];
  playerInsetShadow: Scalars['String'];
  position: Scalars['Int'];
  profilePicture?: Maybe<Attachment>;
  startHour: Scalars['Int'];
  technicalName: Scalars['String'];
  technicalNameHindi: Scalars['String'];
  videoLocation: Scalars['String'];
};

export type TimeSectionAssociatedTimeSectionHourArgs = {
  clientTime: Scalars['ISO8601DateTime'];
};

export type TimeSectionProfilePictureArgs = {
  resolution?: InputMaybe<Scalars['String']>;
};

export type TimeSectionHour = {
  __typename?: 'TimeSectionHour';
  backgroundVideo?: Maybe<Attachment>;
  desktopVideoUrl: Scalars['String'];
  fallbackImage?: Maybe<Attachment>;
  gradientBottomColour?: Maybe<Scalars['String']>;
  gradientTopColour?: Maybe<Scalars['String']>;
  hourNumber: Scalars['Int'];
  id: Scalars['Int'];
  logoVersion?: Maybe<LogoVersion>;
  mobileBackgroundVideo?: Maybe<Attachment>;
  mobileVideoUrl: Scalars['String'];
  playerBackground?: Maybe<Scalars['String']>;
  playerBackgroundMobile?: Maybe<Scalars['String']>;
  playerDropShadow?: Maybe<Scalars['String']>;
  playerInsetShadow?: Maybe<Scalars['String']>;
  praharTextColour: Scalars['String'];
};

export type Transaction = {
  __typename?: 'Transaction';
  amountCents: Scalars['Int'];
  /** Transaction ID stored with apple */
  appleTransactionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currency?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isGift: Scalars['Boolean'];
  /** RazorPay Order ID to pass in transaction with RZP */
  rzpOrderId?: Maybe<Scalars['String']>;
  /** RazorPay Subscription ID that is created to authorize card */
  rzpSubscriptionId?: Maybe<Scalars['String']>;
  /** Current Status of the transaction */
  status: TransactionStatus;
  subscription?: Maybe<Subscription>;
};

export enum TransactionStatus {
  Failed = 'failed',
  InProgress = 'in_progress',
  Success = 'success',
}

export enum Voice {
  Female = 'female',
  Male = 'male',
}
